const Font = {

    // Use the system font instead of the default Roboto font.
    fontFamily: [
        'Inter',
        'BlinkMacSystemFont',
        '"Helvetica Neue"',
        'Helvetica',
        'Arial',
        'sans-serif'
    ].join(','),
    useNextVariants: true
}

export default Font;